import { render, staticRenderFns } from "./EditSubCategoryType.vue?vue&type=template&id=06b81f38&scoped=true&"
import script from "./EditSubCategoryType.vue?vue&type=script&lang=js&"
export * from "./EditSubCategoryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b81f38",
  null
  
)

export default component.exports